/* global fbq:true */
import {Link} from 'react-router'
import styles from './style.css'
import { connect } from 'react-redux'

class RegisterComplete extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  componentDidMount () {
    // Facebook Pixel
    fbq('init', '1661541900796850')
    fbq('track', 'CompleteRegistration')

    // Google Adwords Conversion Tracking
    /* <![CDATA[ */
    window.google_trackConversion({
      google_conversion_id: 950464113,
      google_conversion_label: 'tialCPGY7WQQ8dybxQM',
      google_remarketing_only: false
    })
    // ]]>
  }

  render () {
    return (
      <div className='container'>
        <div className='row' id='registerComplete'>
          <div className='col-md-2'>
            &nbsp;
          </div>
          <div className='col-md-8' id='all-set'>
            <h2 className={`${styles['title']}`}>
              Hi, Welcome on board!
            </h2>
            <br />
            <div className={`col-xs-12 no-padding ${styles['text']}`}>
              <p>
                Thanks for signing up with Moka. Just verify your email address and you're all ready to set up your own outlet.
              </p>
            </div>
            <div className={`col-xs-12 no-padding`}>
              <hr className={`col-xs-12 no-padding ${styles.splitter}`} />
              <div className={`col-xs-12 no-padding text-center`}>
                <img className={`${styles['img-progress']}`} src='https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/register/1+more+step.png' />
              </div>
              <hr className={`col-xs-12 no-padding ${styles.splitter}`} />
            </div>

            <div className={`col-xs-12 no-padding ${styles['text']}`}>
              <h2 className={`${styles['title']}`}>
                Verify Your Account
              </h2>
              <br />
              <p>
                Check <b>{this.props.formRegState.email ? this.props.formRegState.email : 'your.email@website.com'}</b> and click on the link we sent to you.
              </p>
              <br />
              <br />
              <p>
                Haven't received our email? <Link className={`${styles.link}`} activeClassName={`${styles.link}`} to='/resend'>Resend email.</Link>
              </p>
            </div>
          </div>
          <div className='col-md-2'>
            &nbsp;
          </div>
          <div className='clear' />
        </div>
      </div>
    )
  }
}

function select (state) {
  return {
    formRegState: state.moka.formRegState
  }
}

export default connect(select)(RegisterComplete)



// WEBPACK FOOTER //
// ./app/pages/RegisterComplete/RegisterComplete.js